import React from 'react';
import { ClassAssembly1B2025 } from '../views';


const ClassAssemblyPage = () => {
    return <ClassAssembly1B2025/>;
  };
  
  export default ClassAssemblyPage;